import { render, staticRenderFns } from "./Jumbo.vue?vue&type=template&id=33329816"
import script from "./Jumbo.vue?vue&type=script&lang=js"
export * from "./Jumbo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports